<template>
  <vue-date-picker :locale="$i18n.locale" v-model="date" :attributes="this.$data._attributes" @dayclick="dayClickHandler" is-required/>
</template>

<script>
import { DatePicker } from 'v-calendar';
import { dateTimeZoneOffset } from '../../../javascripts/helpers/timeZoneOffsetHelper';

export default{
  components: {
    'vue-date-picker': DatePicker
  },
  data(){
    return {
      _attributes: [
        ...this.attributes
      ],
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
      date: this.dateSelected,
    }
  },
  props:{
    attributes: {
      type: Array,
      default: ()=>[]
    },
    dateSelected:{
      type: Date,
      default: () => new Date()
    }
  },
  methods: {
    dayClickHandler(e){
      let date = dateTimeZoneOffset(e.id)
      this.$emit('ondayclick', date)
    }
  },
  watch: {
    dateSelected: function(newValue){
      this.date = newValue
    }
  }
}
</script>